module.exports = __webpack_public_path__ + "img/logo-fit-service-small.aebd0312.svg";